'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fat';
var iconName = 'rocket-launch';
var width = 512;
var height = 512;
var aliases = [128640];
var unicode = 'e027';
var svgPathData = 'M160.5 288l.1 0c35.3 0 63.9 28.7 63.9 64l0 103.5c0 24.9 27.1 40.2 48.5 27.4L361.2 430c14.5-8.7 23.3-24.3 23.3-41.2l0-95C513.4 217.8 519.9 104.3 508.8 28.4 506.9 15.6 496.9 5.6 484.1 3.7 408.2-7.4 294.7-.9 218.6 128l-95 0c-16.9 0-32.5 8.8-41.2 23.3L29.6 239.5C16.8 260.9 32.1 288 57 288l103.5 0zm19.4-13.6c29.9-127.5 81.9-193.4 135.8-226.5 56.5-34.7 118.1-35.3 166.1-28.3 5.8 .8 10.3 5.3 11.1 11.1 7 48 6.4 109.7-28.3 166.1-33.1 53.8-99 105.8-226.5 135.8-7.1-28.6-29.6-51.1-58.2-58.2zM240.5 352c0-1.2 0-2.4-.1-3.5 51.5-12 93.7-27.6 128.1-45.7l0 86c0 11.2-5.9 21.7-15.5 27.4l-88.2 52.9c-10.7 6.4-24.2-1.3-24.2-13.7l0-103.5zM209.7 144c-18.1 34.4-33.7 76.6-45.7 128.1-1.2-.1-2.3-.1-3.5-.1L57 272c-12.4 0-20.1-13.6-13.7-24.2l52.9-88.2c5.8-9.6 16.2-15.5 27.4-15.5l86 0zm142.8-16a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm80 0a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM141.6 462.3c-12.6 12.6-32.2 21.1-54.4 26.3-21.9 5.2-44.4 6.9-61.1 7.3-5.5 .1-9.6-4-9.5-9.5 .4-16.6 2.1-39.2 7.3-61.1 5.3-22.2 13.7-41.8 26.3-54.4 25.2-25.2 66.1-25.2 91.3 0s25.2 66.1 0 91.3zm11.3 11.3c31.5-31.5 31.5-82.5 0-114s-82.5-31.5-114 0c-31.3 31.3-37.5 92-38.3 126.4-.4 14.6 11.2 26.2 25.9 25.9 34.5-.8 95.1-7 126.4-38.3z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faRocketLaunch = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;